"use client";

import { VehicleMedia } from "@alba-cars/common-modules";
import { useState } from "react";

import DesktopGallery from "./DesktopGallery";
import GalleryModal from "./GalleryModal";
import MobileSwiper from "./MobileSwiper";

interface CarGalleryProps {
  altText: string;
  validImages: VehicleMedia[];
}

const CarGallery: React.FC<CarGalleryProps> = ({ altText, validImages }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  const openModal = (index: number) => {
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <DesktopGallery images={validImages} altText={altText} onImageClickAction={openModal} />

      <MobileSwiper images={validImages} altText={altText} onImageClick={openModal} />

      <GalleryModal
        isOpen={isModalOpen}
        onClose={closeModal}
        images={validImages}
        initialSlide={modalIndex}
        altText={altText}
      />
    </>
  );
};

export default CarGallery;
